export const components = {
  emptyState: {
    primaryTitle: 'Oi, problema!',
    primaryText: 'Turinio dar nėra…',
    secondaryTitle: 'Nėra ką rodyti',
    secondaryText: 'Liūdna, bet pagal pasirinktus filtrus nerasta jokių elementų…'
  },
  filters: {
    all: 'Visi',
    search: 'Paieška',
    priceRange: 'Kainų intervalas {currency}',
    minValue: 'Mažiausia vertė yra {val}!',
    maxValue: 'Didžiausia vertė yra {val}!',
    reset: 'Atstatyti',
    apply: 'Taikyti'
  },
  comments: {
    reply: 'Atsakyti',
    loadMore: 'Įkelti daugiau',
    edited: 'Redaguota',
    noComments: 'Komentarų dar nėra',
    leaveFirstComment: 'Palikite pirmą komentarą'
  },
  curtain: {
    close: 'Uždaryti'
  },
  photoPreview: {
    close: 'Uždaryti'
  },
  photoCropper: {
    back: 'Grįžti',
    save: 'Išsaugoti'
  },
  rightSidebar: {
    in: 'viduje'
  },
  pushPrompt: {
    title: '„{appName}“ nori siųsti jums pranešimus',
    description: 'Pranešimai gali apimti įspėjimus, garsus ir piktogramų ženkliukus. Juos galima konfigūruoti nustatymuose.',
    later: 'Priminti vėliau',
    neverLater: 'Daugiau neklausti',
    allow: 'Leisti'
  },
  inAppPush: {
    attachment: 'Priedas'
  },
  installPrompt: {
    android: {
      install: 'Įdiegti',
      description: 'Kad naudotis būtų patogiau, nereikia naudoti naršyklės. Tiesiog įdiekite kaip programėlę.',
      press: 'Paspauskite',
      andSelect: 'ir pasirinkite',
      orSimply: 'arba tiesiog',
      description2: 'spauskite mygtuką „Įdiegti“ žemiau',
      notNow: 'Ne dabar'
    },
    ios: {
      justTap: 'Palieskite',
      buttonInBrowser: '„Daugiau" mygtuką naršyklėje ir pasirinkite „Bendrinti"',
      addToHomeScreen: 'Slinkite žemyn ir palieskite „Pridėti prie pradžios ekrano", tada spustelėkite „Pridėti"',
      appWillBeInstalled: 'Programėlė bus pridėta prie jūsų pradžios ekrano'
    },
    installApp: 'Įdiegti programėlę',
    useWeb: 'Naudoti žiniatinklio versiją'
  },
  footer: {
    more: 'Meniu'
  },
  menu: {
    installApp: 'Įdiegti programėlę',
    menu: 'Meniu',
    close: 'Uždaryti'
  },
  404: {
    whoops: 'Oi!',
    description: 'Puslapis neegzistuoja arba jūs neturite prieigos. Daugiau informacijos kreipkitės į programėlės savininką.',
    ok: 'Gerai'
  },
  relatedUsers: {
    seeall: 'Rodyti visus'
  },
  camera: {
    NotAllowedError: 'Norėdami nuskaityti QR kodus, įjunkite prieigą prie kameros savo įrenginio nustatymuose.',
    NotFoundError: 'Kamera nerasta. Patikrinkite, ar jūsų įrenginyje yra veikianti kamera.',
    NotSupportedError: 'Prieigai prie kameros reikalingas saugus HTTPS ryšys.',
    NotReadableError: 'Nepavyko pasiekti kameros. Ji gali būti naudojama kitos programos.',
    OverconstrainedError: 'Prašoma kamera neprieinama. Patikrinkite kameros nustatymus.',
    StreamApiNotSupportedError: 'Jūsų naršyklė nepalaiko reikiamų kameros funkcijų.'
  },
  networkingCurtain: {
    'newOneOnOne': 'Naujas 1:1',
    'details': 'Išsami informacija',
    'coverMessage': 'Pristatymo žinutė',
    'location': 'Vieta',
    'duration': 'Trukmė',
    '15min': '15 min',
    '30min': '30 min',
    '45min': '45 min',
    '60min': '60 min',
    'timeSlot': 'Laiko tarpas',
    'sendInvitation': 'Siųsti kvietimą',
    'success': 'Sėkmingai',
    'invitationSent':
      'Kvietimas į 1:1 susitikimą išsiųstas sėkmingai. Ar norite likti šiame puslapyje, ar pereiti prie visų suplanuotų susitikimų?',
    'seeAll': 'Peržiūrėti visus 1:1 susitikimus',
    'stayHere': 'Likti čia'
  },
  networking: {
    level: {
      1: 'Dar nepasiruošęs tinklaveikai. Nėra reikšmingo aktyvumo ar įsitraukimo.',
      2: 'Retai aktyvus arba trūksta svarbios profilio informacijos, dėl ko sunku užmegzti ryšį.',
      3: 'Profilis užpildytas su nuotrauka ir aktyvus – pasiruošęs pradėti tinklaveiką.',
      4: 'Pradeda aktyvumą – bent vienas ryšys per pastarąsias 6 valandas.',
      5: 'Tinklaveikos meistras – aktyviai atsakinėja į užklausas ir bendrauja per paskutines 6 valandas.'
    }
  },
  time: {
    days: 'd.',
    hours: 'val.',
    minutes: 'min.',
    seconds: 'sek.',
    startsIn: 'po',
    Today: 'Šiandien',
    today: 'šiandien',
    Tomorrow: 'Rytoj',
    tomorrow: 'rytoj',
    Yesterday: 'Vakar',
    yesterday: 'vakar',
    startingNow: 'prasideda dabar'
  },
  daysMonths: {
    months:
      "['Sausis','Vasaris','Kovas','Balandis','Gegužė','Birželis','Liepa','Rugpjūtis','Rugsėjis','Spalis','Lapkritis','Gruodis']",
    monthsShort: "['Sau', 'Vas', 'Kov', 'Bal', 'Geg', 'Bir', 'Lie', 'Rgp', 'Rgs', 'Spa', 'Lap', 'Grd']",
    weekdays: "['Sekmadienis', 'Pirmadienis', 'Antradienis', 'Trečiadienis', 'Ketvirtadienis', 'Penktadienis', 'Šeštadienis']",
    weekdaysShort: "['Sek', 'Pir', 'Ant', 'Tre', 'Ket', 'Pen', 'Šeš']",
    weekdaysMin: "['S', 'P', 'A', 'T', 'K', 'Pn', 'Š']"
  },
  badges: {
    legend: 'Legendinis tinklaveikos dalyvis',
    push: 'Prisijungęs ir patikimas',
    leader: 'Lyderių sąrašo čempionas',
    meetmaster: '1:1 susitikimų meistras',
    connector: '3 kartus sujungęs',
    legend_description: 'Pasiekite legendos lygį bent kartą aktyviai dalyvaudami tinklaveikoje.',
    push_description: 'Įjunkite pranešimus, kad liktumėte pasiekiamas ir nepraleistumėte galimybių.',
    leader_description: 'Patekti į geriausiųjų 10% sąrašą bent kartą.',
    meetmaster_description: 'Pradėkite arba atsakykite į bent vieną 1:1 susitikimo užklausą per programėlę.',
    connector_description: 'Sukurkite bent tris ryšius per programėlę renginio metu.'
  }
}
